// src/lib/parsers.ts
function createParser(parser) {
  return {
    ...parser,
    parseServerSide(value = "") {
      let str = "";
      if (Array.isArray(value)) {
        str = value[0];
      }
      if (typeof value === "string") {
        str = value;
      }
      return this.parse(str);
    },
    withDefault(defaultValue) {
      const nullableParse = this.parseServerSide.bind(this);
      return {
        ...this,
        defaultValue,
        parseServerSide(value = "") {
          return nullableParse(value) ?? defaultValue;
        }
      };
    },
    withOptions(options) {
      return {
        ...this,
        ...options
      };
    }
  };
}
var parseAsString = createParser({
  parse: (v) => v,
  serialize: (v) => `${v}`
});
var parseAsInteger = createParser({
  parse: (v) => {
    const int = parseInt(v);
    if (Number.isNaN(int)) {
      return null;
    }
    return int;
  },
  serialize: (v) => Math.round(v).toFixed()
});
var parseAsHex = createParser({
  parse: (v) => {
    const int = parseInt(v, 16);
    if (Number.isNaN(int)) {
      return null;
    }
    return int;
  },
  serialize: (v) => {
    const hex = Math.round(v).toString(16);
    return hex.padStart(hex.length + hex.length % 2, "0");
  }
});
var parseAsFloat = createParser({
  parse: (v) => {
    const float = parseFloat(v);
    if (Number.isNaN(float)) {
      return null;
    }
    return float;
  },
  serialize: (v) => v.toString()
});
var parseAsBoolean = createParser({
  parse: (v) => v === "true",
  serialize: (v) => Boolean(v) ? "true" : "false"
});
var parseAsTimestamp = createParser({
  parse: (v) => new Date(parseInt(v)),
  serialize: (v) => v.valueOf().toString()
});
var parseAsIsoDateTime = createParser({
  parse: (v) => new Date(v),
  serialize: (v) => v.toISOString()
});
function parseAsStringEnum(validValues) {
  return createParser({
    parse: (query) => {
      const asEnum = query;
      if (validValues.includes(asEnum)) {
        return asEnum;
      }
      return null;
    },
    serialize: (value) => value.toString()
  });
}
function parseAsJson(parser) {
  return createParser({
    parse: (query) => {
      try {
        const obj = JSON.parse(query);
        if (typeof parser === "function") {
          return parser(obj);
        } else {
          return obj;
        }
      } catch {
        return null;
      }
    },
    serialize: (value) => JSON.stringify(value)
  });
}
function parseAsArrayOf(itemParser, separator = ",") {
  return createParser({
    parse: (query) => {
      if (query === "") {
        return [];
      }
      return query.split(separator).map((item) => decodeURIComponent(item)).map(itemParser.parse).filter((value) => value !== null && value !== void 0);
    },
    serialize: (values) => values.map((value) => {
      if (itemParser.serialize) {
        return itemParser.serialize(value);
      }
      return `${value}`;
    }).map(encodeURIComponent).join(separator)
  });
}

export {
  createParser,
  parseAsString,
  parseAsInteger,
  parseAsHex,
  parseAsFloat,
  parseAsBoolean,
  parseAsTimestamp,
  parseAsIsoDateTime,
  parseAsStringEnum,
  parseAsJson,
  parseAsArrayOf
};
